import { type CountryCode, type ProjectCode } from '@constants'
import { useUpdatePopupCandidates } from '@popup/hooks/useUpdatePopupCandidates'
import { Popup } from '@popup/Popup'
import { useMemo } from 'react'

interface PopupWrapperProps {
  projectCode: ProjectCode
  campaignId: number
  countryCode: CountryCode
}

export const PopupWrapper = (props: PopupWrapperProps) => {
  const { projectCode, campaignId, countryCode } = props
  const { popupCandidates } = useUpdatePopupCandidates({ projectCode, campaignId, countryCode })
  const popups = popupCandidates?.data?.popups
  const popupSettings = useMemo(() => ({
    interval_hours: popupCandidates?.data?.popup_settings?.interval_hours,
    daily_user_limit: popupCandidates?.data?.popup_settings?.daily_user_limit,
  }), [popupCandidates])

  if (!popupCandidates) return null

  return (
    <Popup
      campaignId={campaignId}
      popups={popups}
      intervalHours={popupSettings.interval_hours}
      dailyUserLimit={popupSettings.daily_user_limit}
    />
  )
}
